// src/utils/authState.js
import { reactive } from 'vue'

/**
 * Реактивное состояние для отслеживания процесса logout
 * Используется для обхода navigation guards при выходе из системы
 */
export const authState = reactive({
  isLoggingOut: false,
  
  /**
   * Начать процесс logout
   * Вызывать ПЕРЕД навигацией на страницу авторизации
   */
  startLogout() {
    this.isLoggingOut = true
    console.log('🔐 [authState] Logout started')
  },
  
  /**
   * Завершить процесс logout
   * Вызывать ПОСЛЕ успешной навигации или при ошибке
   */
  finishLogout() {
    this.isLoggingOut = false
    console.log('🔐 [authState] Logout finished')
  },
  
  /**
   * Сбросить состояние (например, при монтировании auth страницы)
   */
  reset() {
    this.isLoggingOut = false
  }
})

export default authState
